import React, { useEffect, useState } from 'react'

import {
  Breadcrumb,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Icon,
  LocaleProvider,
  Modal,
  Row,
  Select,
  Typography,
  notification
} from 'antd'
import ptBR from 'antd/es/locale/pt_BR'
import { Formik } from 'formik'
import { get } from 'lodash'
import moment from 'moment'
import * as yup from 'yup'

import CustomInput from '../../components/CustomInput/customInput'
import CustomSelect from '../../components/CustomSelect/customSelect'
import FormHeader from '../../components/FormHeader/FormHeader'
import SelectOrganization from '../../components/SelectOrganization/SelectOrganization'
import { RULES, validRule } from '../../constants/Entitlements'
import { getMessage } from '../../util/IntlMessages'
import { api, request } from '../../util/handlerRequestUtil'
import { orderObjects } from '../../util/orderObjects'
const { Option } = Select
const { confirm } = Modal

moment.updateLocale(moment.locale('pt-br'), { invalidDate: '-' })

const CreateJourneys = ({ match, history }) => {
  // Params url
  const { id } = match.params

  // UseStates
  const [isReadOnly, setIsReadOnly] = useState(false)
  const [formValues, setFormValues] = useState({})
  // Custom states
  const [actionTypesList, setActionTypesList] = useState([])
  const [actionTemplateItemListDeleted, setActionTemplateItemListDeleted] = useState([])
  const [referencePeriodList, setReferencePeriodList] = useState([])

  const MarginButton = { marginTop: 26 }

  // Mount/Umount component
  useEffect(() => {
    const hasAccess = validRule(RULES.ACTION_TEMPLATE) // Não deixa acessar a tela

    if (!hasAccess) {
      return history.push('/home')
    }

    checkIsReadOnly()
    onCreateContainer()
    if (id) {
      retrieveJourney(id)
    } else {
      addJourneyItem()
    }

    return () => {
      setIsReadOnly(false)
    }
  }, [])

  // Async queue
  async function onCreateContainer() {
    await listActionTypes({ ignorePagination: true, active: true })
    await listReferencePeriod({ ignorePagination: true })
  }

  // List action types
  async function listActionTypes(params) {
    try {
      const response = await request(api.listActionTypes(params))
      console.tron.log('response listActionTypes', response)

      const formattedData = response.map((item) => ({
        value: get(item, 'id'),
        description: get(item, 'name')
      }))

      formattedData.sort(orderObjects('description'))
      setActionTypesList(formattedData)
    } catch (error) {
      console.tron.log(error)
    }
  }

  // List reference period
  async function listReferencePeriod(params) {
    try {
      const response = await request(api.listReferencePeriod(params))
      console.tron.log('response listReferencePeriod', response)

      const formattedData = []
      response.map((item) => {
        return formattedData.push({
          value: get(item, 'id'),
          description: get(item, 'name')
        })
      })

      formattedData.sort(orderObjects('description'))

      setReferencePeriodList(formattedData)
    } catch (error) {
      console.error(error)
      console.tron.log(error)
    }
  }

  // Cruds
  async function retrieveJourney(id) {
    try {
      const response = await request(api.retrieveActionTemplates(id))
      console.tron.log('response retrieveJourney', response)
      const values = {
        id: get(response, 'id'),
        journeyName: get(response, 'name'),
        journeyHarvest: get(response, 'referencePeriodId'),
        active: get(response, 'active', 'true'),
        organization: get(response, 'organizationId'),
        journeyItems: get(response, 'actionTemplateItems', []),
        allowUpdate: get(response, 'allowUpdate', 'true'),
        templateStatus: get(response, 'templateStatus', 'true'),
        created_at: get(response, 'created_at', 'true'),
        updated_at: get(response, 'updated_at', 'true')
      }

      if (values.journeyItems.length <= 0) {
        const journeyItem = {
          actionTemplateId: values.id,
          actionTypeId: '',
          plannedStartTime: moment(),
          plannedEndTime: moment(),
          active: true
        }

        values.journeyItems.push(journeyItem)
      }

      if (values.templateStatus === 'EXECUTADA') {
        setIsReadOnly(true)
      }

      setFormValues(values)
    } catch (error) {
      console.tron.log(error)
    }
  }

  // Form/formik config
  const form = {
    initialValues: formValues,
    yupValidationCreate: yup.object().shape({
      journeyName: yup
        .string()
        .max(60)
        .typeError('must be string')
        .required(getMessage('isRequired', getMessage('journeyName'))),
      organization: yup
        .string()
        .max(60)
        .typeError('must be string')
        .required(getMessage('isRequired', getMessage('organization'))),
      journeyHarvest: yup
        .string()
        .max(60)
        .required(getMessage('isRequired', getMessage('journeyHarvest')))
    }),
    yupValidationUpdate: yup.object().shape({
      journeyName: yup
        .string()
        .max(60)
        .typeError('must be string')
        .required(getMessage('isRequired', getMessage('journeyName'))),
      organization: yup
        .string()
        .max(60)
        .typeError('must be string')
        .required(getMessage('isRequired', getMessage('organization'))),
      journeyHarvest: yup
        .string()
        .max(60)
        .required(getMessage('isRequired', getMessage('journeyHarvest')))
    }),
    onSubmit: async (values) => {
      let payload
      let executeJourney = false
      let containsJourneyAction = false

      const data = {
        name: get(values, 'journeyName', ''),
        referencePeriodId: parseInt(get(values, 'journeyHarvest', ''), 10),
        actionTemplateItems: get(values, 'journeyItems', ''),
        organizationId: get(values, 'organization', ''),
        allowUpdate: true,
        templateStatus: 'PENDENTE'
      }

      // Validation templateName and referencePeriodId not empty
      if (data.templateName === '' || data.referencePeriodId === null) {
        notification.warn({
          description: getMessage('validationNotEmptyInformationsExecuteJourney'),
          message: 'Atenção'
        })
        return
      }

      // Set parseInt
      for (const actionTemplateItem of data.actionTemplateItems) {
        if (actionTemplateItem.actionTypeId !== null && actionTemplateItem.actionTypeId !== '') {
          actionTemplateItem.actionTypeId = parseInt(actionTemplateItem.actionTypeId, 10)
          containsJourneyAction = true
        }

        if (actionTemplateItem.actionTemplateId) {
          actionTemplateItem.actionTemplateId = parseInt(actionTemplateItem.actionTemplateId, 10)
        }
      }

      for (let item = 1; item < values.journeyItems.length; item++) {
        if (containsJourneyAction && values.journeyItems[item].actionTypeId === '') {
          data.actionTemplateItems.splice(item, 1)
        }
      }

      // Validation not empty journey action
      if (!containsJourneyAction) {
        notification.warn({
          description: getMessage('validationNotEmptyJourneyAction'),
          message: 'Atenção'
        })
        return
      }

      if (values.executeJourney !== null) {
        executeJourney = values.executeJourney
      }

      if (id) {
        payload = { id, data }
        await updateJourney(payload)
      } else {
        payload = await storeJourney(data)
      }

      if (executeJourney && payload !== null && payload.id !== null) {
        await generationJourney(payload.id)
      }

      history.push('/journeys/list')
    }
  }

  // Execute generation Action Template(Journey)
  async function generationJourney(id) {
    try {
      await request(api.generationActionTemplates(id, ''))
      notification.success({
        description: getMessage('successGenerateActionJourney'),
        message: getMessage('sweetAlerts.success')
      })
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function deleteJourneyItem() {
    if (actionTemplateItemListDeleted !== null && actionTemplateItemListDeleted.length > 0) {
      for (const journeyItem of actionTemplateItemListDeleted) {
        await request(api.destroyActionTemplateItem(journeyItem.id, ''))
      }
    }
  }

  // Create journey and journey items
  async function storeJourney(data) {
    try {
      const response = await request(api.storeActionTemplates(data))
      notification.success({
        description: getMessage('successCreateActionTypes'),
        message: getMessage('sweetAlerts.success')
      })
      setFormValues({})
      return response
    } catch (error) {
      console.tron.log(error)
    }
  }

  // Update journey and journey items
  async function updateJourney(payload) {
    try {
      console.tron.log('updateCustomerTypes')
      const { id, data } = payload
      await request(api.updateActionTemplates(id, data)).then(await deleteJourneyItem())
      notification.success({
        description: getMessage('successUpdateActionTypes'),
        message: getMessage('sweetAlerts.success')
      })
      setFormValues({})
    } catch (error) {
      console.tron.log(error)
    }
  }

  // Add journey item
  async function addJourneyItem() {
    let journeyItem = {
      actionTypeId: '',
      plannedStartTime: moment(),
      plannedEndTime: moment(),
      active: true
    }

    const formValuesSecundary = { ...formValues, journeyItems: formValues.journeyItems || [] }

    if (formValuesSecundary.id) {
      journeyItem = { ...journeyItem, actionTemplateId: parseInt(formValuesSecundary.id, 10) }
    }

    formValuesSecundary.journeyItems.push(journeyItem)
    setFormValues(formValuesSecundary)
  }

  // Remove journey item
  async function removeJourneyItem(order) {
    const formValuesSecundary = { ...formValues }
    const journeyItem = formValuesSecundary.journeyItems[order]

    if (journeyItem.id !== null) {
      if (actionTemplateItemListDeleted === null) {
        setActionTemplateItemListDeleted([])
      }

      actionTemplateItemListDeleted.push(journeyItem)
      setActionTemplateItemListDeleted(actionTemplateItemListDeleted)
    }

    formValuesSecundary.journeyItems.splice(order, 1)
    setFormValues(formValuesSecundary)
  }

  // Render options action type list
  const renderOptions = () => {
    const options = []
    for (const type of actionTypesList) {
      options.push(
        <Option key={`key-${type.value}`} value={type.value}>
          {type.description}{' '}
        </Option>
      )
    }

    return options
  }

  // Disable date
  function disabledDate(current) {
    return current && current < moment().startOf('day')
  }

  // Content modal
  const contentExecuteModal = (
    <div>
      <b>Atenção!</b> Ao executar uma jornada, todas as visitas serão automaticamente criadas e vinculadas nas agendas
      dos profissionais.
      <br />
      <br />
      <b>Esta jornada não poderá ser alterada ou cancelada!</b>
      <br />
      <br />
      Deseja prosseguir com a execução?
    </div>
  )

  // Modal execute Journey
  function showConfirm() {
    confirm({
      title: getMessage('titleModalExecuteJourney'),
      okText: 'Confirmar',
      cancelText: 'Cancelar',
      icon: null,
      content: contentExecuteModal,
      onOk() {
        form.onSubmit({ ...formValues, executeJourney: true })
      },
      onCancel() {}
    })
  }

  // Render journey items
  function renderJourneyItems(isReadOnly) {
    const cards = []

    const setFieldValueWithStateJourneyItem = (field, value, index) => {
      const journeyItems = formValues.journeyItems

      if (Array.isArray(journeyItems)) {
        journeyItems[index][field] = value
        setFormValues({ ...formValues, journeyItems })
      }
    }

    if (Array.isArray(formValues.journeyItems)) {
      for (let item = 0; item < formValues.journeyItems.length; item++) {
        cards.push(
          <Row type="flex" justify="start">
            <Col span={12}>
              <p>{getMessage('actionTypeId')}</p>
              <Select
                disabled={isReadOnly === true || false}
                style={{ width: '100%', marginBottom: '20px' }}
                value={formValues.journeyItems[item].actionTypeId}
                placeholder={getMessage('select')}
                onChange={(e) => setFieldValueWithStateJourneyItem('actionTypeId', e, item)}
              >
                {renderOptions()}
              </Select>
            </Col>
            <Col span={5}>
              <p>{getMessage('plannedStartTime')}</p>
              <LocaleProvider locale={ptBR}>
                <DatePicker
                  disabled={isReadOnly === true || false}
                  style={{ width: '100%' }}
                  disabledDate={disabledDate}
                  allowClear={false}
                  value={moment(formValues.journeyItems[item].plannedStartTime)}
                  format="DD/MM/YYYY"
                  suffixIcon={null}
                  onChange={(e) => setFieldValueWithStateJourneyItem('plannedStartTime', e, item)}
                />
              </LocaleProvider>
            </Col>
            <Col span={5}>
              <p>{getMessage('plannedEndTime')}</p>
              <LocaleProvider locale={ptBR}>
                <DatePicker
                  disabled={isReadOnly === true || false}
                  style={{ width: '100%' }}
                  disabledDate={disabledDate}
                  allowClear={false}
                  value={moment(formValues.journeyItems[item].plannedEndTime)}
                  format="DD/MM/YYYY"
                  suffixIcon={null}
                  onChange={(e) => setFieldValueWithStateJourneyItem('plannedEndTime', e, item)}
                />
              </LocaleProvider>
            </Col>

            {formValues.journeyItems.length - 1 === item && (
              <Button
                icon="plus"
                style={MarginButton}
                disabled={isReadOnly === true || false}
                type="primary"
                onClick={() => addJourneyItem()}
              />
            )}
            {formValues.journeyItems.length - 1 !== item && (
              <Button
                icon="close"
                style={MarginButton}
                disabled={isReadOnly === true || false}
                type="secundary"
                onClick={() => removeJourneyItem(item)}
              />
            )}
          </Row>
        )
      }
    }

    return cards
  }

  // Common
  function checkIsReadOnly() {
    const searchParams = new URLSearchParams(window.location.search)
    const { readOnly } = Object.fromEntries(searchParams.entries())
    if (readOnly) {
      setIsReadOnly(true)
    } else {
      setIsReadOnly(false)
    }
  }

  // Title
  function getTitle() {
    return id !== null ? getMessage('updateJourneys') : getMessage('createJourneys')
  }

  // Header
  function renderHeader(submitForm) {
    const hasAccess = id === undefined ? validRule(RULES.ACTION_TEMPLATE) : validRule(RULES.ACTION_TEMPLATE)
    const hasAccessCreateActions = validRule(RULES.ACTION)

    return (
      <div className="default-header-div">
        <div className="default-header-breadcrumb">
          {/* <CustomBreadcrumb match={match} history={history} /> */}
          <Breadcrumb>
            <Breadcrumb.Item onClick={() => history.push('/')}>
              <Icon
                type="home"
                theme="filled"
                style={{ fontSize: '16px', color: '#263447' }}
                onClick={() => history.push('/')}
              />
            </Breadcrumb.Item>
            <Breadcrumb.Item onClick={() => history.push('/journeys/list')}>Jornadas</Breadcrumb.Item>
            <Breadcrumb.Item>{`${
              match.params.id ? 'Atualizar dados da jornada' : 'Cadastrar jornada'
            }`}</Breadcrumb.Item>
          </Breadcrumb>
          <div className="default-header-buttons">
            <Button onClick={() => history.goBack()}>
              <Icon type="left" theme="outlined" className="default-back-icon" />
              {getMessage('back')}
            </Button>
            {!isReadOnly && hasAccess && (
              <Button className="button" type="primary" onClick={() => submitForm()}>
                {id ? getMessage('update') : getMessage('register')}
              </Button>
            )}
            {!isReadOnly && hasAccessCreateActions && id > 0 && (
              <Button type="primary" onClick={showConfirm}>
                {id ? getMessage('journeyExecuteTemplate') : getMessage('journeyExecuteTemplate')}
              </Button>
            )}
          </div>
        </div>
      </div>
    )
  }

  // Main component
  return (
    <Formik
      enableReinitialize
      validationSchema={!id ? form.yupValidationCreate : form.yupValidationUpdate}
      initialValues={formValues}
      onSubmit={(values, { setSubmitting, setFieldError, resetForm }) =>
        form.onSubmit(values, setSubmitting, setFieldError, resetForm)
      }
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({ errors, handleBlur, handleSubmit, setFieldValue, submitForm }) => {
        const setFieldValueWithState = (field, value) => {
          setFormValues({ ...formValues, [field]: value })
          return setFieldValue(field, value)
        }

        return (
          <Form layout="vertical" onSubmit={handleSubmit}>
            {renderHeader(submitForm)}
            <Card className="ant-card gx-card ant-card-bordered">
              <Typography.Title className="default-header-title" level={3}>
                {getTitle()}
              </Typography.Title>
              <Row type="flex" justify="start">
                <CustomInput
                  disabled={isReadOnly}
                  field="journeyName"
                  errors={errors}
                  setFieldValue={setFieldValueWithState}
                  rowSpan={8}
                  value={formValues}
                  handleBlur={handleBlur}
                  required
                />
                <CustomSelect
                  showSearch
                  enable={isReadOnly}
                  field="journeyHarvest"
                  errors={errors}
                  setFieldValue={setFieldValueWithState}
                  rowSpan={8}
                  value={formValues}
                  values={referencePeriodList}
                  handleBlur={form.handleBlur}
                  required
                />
                <SelectOrganization
                  field="organization"
                  rowSpan={8}
                  formValues={formValues}
                  setFieldValue={setFieldValueWithState}
                  errors={errors}
                  handleBlur={form.handleBlur}
                  disabled={isReadOnly}
                  required
                />
              </Row>
              <FormHeader title={getMessage('tab.actionsJorney')} orientation="left" type="horizontal" />
              {renderJourneyItems(isReadOnly)}
            </Card>
          </Form>
        )
      }}
    </Formik>
  )
}

export default CreateJourneys
